// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2ba9e0c3bb8479567fb090b1cd2101799363fd12/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};